import React, {
  ChangeEvent,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { AddTextAreaField } from "./container/components/AddTextAreaField";
import { AddTextField } from "./container/components/AddTextField";

interface editLayoutTextProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (name: string, description: string) => void;
  itemName?: string;
  description?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const EditLayoutText = ({
  isOpen,
  onClose,
  onSave,
  itemName,
  description,
  onChange,
}: editLayoutTextProps) => {
  const [name, setName] = useState(itemName || "");
  const [desc, setDesc] = useState(description || "");
  const [originalDesc, setOriginalDesc] = useState(description || ""); // Track original description
  const charAllowed = 150;
  const cdescriptionCarAllowed = 300;
  const [error, setError] = useState<string>("");
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [isValidInput, setIsValidInput] = useState(false);
  const [isDescChanged, setIsDescChanged] = useState(false); // Track if description has changed

  useEffect(() => {
    setName(itemName || "");
    setDesc(description || "");
    setOriginalDesc(description || ""); // Set original description when component loads
  }, [itemName, description]);

  useEffect(() => {
    setIsValidInput(name.length >= 3 && desc.length >= 3);
    setIsDescChanged(desc !== originalDesc); // Check if description has changed
  }, [name, desc, originalDesc]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-96">
        <div className="relative w-full min-w-[200px] mb-2">
          <div className="flex items-center space-x-2">
            <span className="content_title">Edit List Item</span>
          </div>
          <p className="notes-class-content">
            Update the item name or Description.
          </p>
          <div className="flex input-class mb-[15px] bg-slate-500">
            <input
              type="text"
              name="listName"
              id="listName"
              className="input-text bg-gray-400"
              placeholder="List Item"
              readOnly
              maxLength={charAllowed}
              value={name}
            />
          </div>
          <div>
            <AddTextAreaField
              name={"itemDescription"}
              title={"itemDescription"}
              note={"Maximum text length of 500 characters."}
              placeholder={"Item Description"}
              index={2}
              height={150}
              charAllowed={cdescriptionCarAllowed}
              value={desc}
              onChange={(e) => {
                setDesc(e.target.value);
                if (onChange) onChange(e);
              }}
            />
            {/* 
            <AddTextField
              name={"itemDescription"}
              title={"itemDescription"}
              placeholder={"Item Description"}
              index={2}
              charAllowed={cdescriptionCarAllowed}
              value={desc}
              onChange={(e) => {
                setDesc(e.target.value);
                if (onChange) onChange(e);
              }}
            /> */}
          </div>
          <div className="flex justify-center max-w-[480px] gap-10 mt-[15px]">
            <button
              type="submit"
              onClick={() => onSave(name, desc)}
              disabled={!isValidInput || !isDescChanged}
              className={
                isValidInput && isDescChanged
                  ? "bg-black cursor-pointer text-white px-3 py-2 text-sm font-normal text-center p-1 border-2 rounded-lg w-1/2"
                  : "bg-gray-400 disabled-link px-3 py-2 text-sm font-normal text-center p-1 border-2 rounded-lg w-1/2"
              }
            >
              Done
            </button>
            <button
              type="button"
              onClick={onClose}
              className={
                "flex bg-white cursor-pointer items-center justify-center px-3 py-2 text-sm font-normal text-center p-1 border-2 border-black text-black rounded-lg w-1/2"
              }
            >
              Cancel
            </button>
          </div>

          {/* <div className="flex justify-center w-full  gap-10">
          <button
            type="submit"
            onClick={() => onSave(name, desc)}
            className={
              isValidInput && isDescChanged
                ? "bg-black cursor-pointer text-white px-3 py-2 text-sm font-normal text-center p-1 border-2 rounded-lg w-1/2"
                : "bg-gray-400 disabled-link px-3 py-2 text-sm font-normal text-center p-1 border-2 rounded-lg w-1/2"
            }
            disabled={!isValidInput || !isDescChanged} // Disable button if desc hasn't changed or input isn't valid
          >
            Done
          </button>
          <button
            type="button"
            onClick={onClose}
            className={
              "flex bg-white cursor-pointer items-center justify-center px-3 py-2 text-sm font-normal text-center p-1 border-2 border-black text-black rounded-lg w-1/2"
            }
          >
            Cancel
          </button>
        </div> */}
        </div>
      </div>
    </div>
  );
};
